import axios from 'axios'
const Config = require('./config')

// 创建axios实例
const service = axios.create({
  baseURL: Config.BASE_API, // api 的 base_url
  timeout: 30000 // 请求超时时间
})

export function getHeaders() {
  let headers = {}
  return headers
}

// request拦截器
service.interceptors.request.use(
  config => {
    let zdyHeaders = getHeaders()
    config.headers = { ...config.headers, ...zdyHeaders }
    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    const res = response.data
    if (res.http_status !== 200) {
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
